var _g, _defs, _rect, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "450.572px",
    height: "473.658px",
    viewBox: "0 0 450.572 473.658",
    enableBackground: "new 0 0 450.572 473.658",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M345.354,326.256c-2.154,1.646-4.385,3.196-6.688,4.644 l-23.358-13.908l15.098-9.044l14.948-8.955V326.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M363.26,307.938c-4.307,5.907-9.326,11.265-14.932,15.943 v-24.889L363.26,307.938z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "344.162,296.139 329.108,305.156 314.161,314.111  314.161,278.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "345.545,257.675 345.545,275.619 345.545,293.473  315.482,275.574  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M316.798,238.706l12.311,7.375l14.978,8.972l-29.925,17.818 v-5.578c1.685-3.342,2.637-7.111,2.637-11.092V238.706z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "379.017,150.962 348.769,168.803 348.761,151.021  348.752,133.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "65.317,296.162 50.049,305.224 34.887,314.221  34.87,278.241  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "31.85,272.961 1.356,255.013 16.671,245.924  31.832,236.927  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "66.709,335.271 36.217,317.323 51.531,308.234  66.693,299.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "69.712,299.236 84.881,308.22 100.082,317.222  69.728,335.126  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "136.46,335.271 105.967,317.323 121.281,308.234  136.443,299.237  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "139.462,299.236 154.632,308.22 169.833,317.222  139.479,335.126  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M206.211,335.271l-30.494-17.948l15.315-9.089l12.832-7.614 c0.789,0.638,1.566,1.285,2.331,1.945L206.211,335.271z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M226.069,325.192l-16.841,9.934l-0.014-29.841 C215.551,311.244,221.046,317.988,226.069,325.192z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "31.868,189.654 16.698,180.67 1.299,171.551  31.852,153.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "30.265,150.962 0.017,168.803 0.009,151.021 0,133.148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "31.85,148.393 1.356,130.443 16.671,121.355  31.832,112.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "31.813,195.284 31.82,213.301 31.828,231.227  1.319,213.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "65.317,46.992 50.049,56.054 34.887,65.052  34.87,29.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "66.702,8.373 66.711,26.39 66.719,44.314 36.21,26.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "136.453,8.373 136.461,26.39 136.47,44.314  105.961,26.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "100.015,26.36 69.767,44.201 69.759,26.42 69.75,8.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "206.204,8.373 206.212,26.39 206.22,44.314  175.711,26.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "169.766,26.36 139.518,44.201 139.51,26.42  139.501,8.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "275.954,8.373 275.962,26.39 275.97,44.314  245.462,26.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "239.516,26.36 209.268,44.201 209.26,26.42  209.252,8.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "31.813,70.684 31.82,88.7 31.828,106.625 1.319,88.669  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "379.18,109.303 363.911,118.364 348.749,127.362  348.732,91.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "345.711,86.102 315.219,68.153 330.533,59.065  345.695,50.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "310.871,65.053 295.7,56.069 280.301,46.949  310.854,28.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "344.319,46.992 329.051,56.054 313.889,65.052  313.872,29.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "309.267,26.36 279.019,44.201 279.011,26.42  279.002,8.547  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "348.714,174.668 363.884,183.651 379.084,192.653  348.73,210.557  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M31.814,323.592c-0.837-0.744-1.658-1.507-2.464-2.287 l2.462-1.452L31.814,323.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M61.065,340.235c-9.552-3.085-18.445-7.838-26.202-14.066 l-0.003-6.142l30.265,17.813L61.065,340.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M66.713,341.845c-0.566-0.141-1.131-0.287-1.692-0.438 l1.691-0.997L66.713,341.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M74.583,343.408c-1.63-0.245-3.247-0.537-4.852-0.873 l-0.001-1.983L74.583,343.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M101.574,344.365H87.423c-1.864,0-3.722-0.061-5.568-0.18 l-10.784-6.348l30.492-17.985l0.009,18.017L101.574,344.365z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "123.813,344.365 104.622,344.365 104.619,337.9  104.611,320.027 134.875,337.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "136.465,344.365 129.755,344.365 136.463,340.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "145.96,344.365 139.482,344.365 139.48,340.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "171.324,344.365 151.91,344.365 140.821,337.838  171.313,319.853 171.321,337.869  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "193.564,344.365 174.373,344.365 174.37,337.9  174.361,320.027 204.626,337.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "206.215,344.365 199.506,344.365 206.213,340.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "215.71,344.365 209.232,344.365 209.231,340.552  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M238.083,344.365h-16.422l-11.09-6.527l17.208-10.149 C231.397,333.062,234.784,338.662,238.083,344.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M201.022,298.415l-11.473,6.809l-15.162,8.997l-0.014-29.182 C184.694,288.181,193.43,292.769,201.022,298.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M171.355,284.172l0.014,30.051l-15.17-8.984l-15.4-9.119 l23.131-13.643C166.49,282.965,168.966,283.529,171.355,284.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M139.512,281.21h16.049c1.269,0.146,2.519,0.308,3.748,0.488 l-19.791,11.673L139.512,281.21z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "115.615,281.21 136.464,281.21 136.47,293.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "104.622,281.21 109.664,281.21 135.068,296.162  119.799,305.224 104.638,314.221  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "96.326,281.21 101.604,281.21 101.619,314.223  86.448,305.238 71.049,296.119  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M69.758,273.491c0.181,0.192,0.362,0.381,0.549,0.567 l0.422,0.427l-0.211,0.199c4.333,4.043,10.482,6.525,16.905,6.525h2.963l-20.619,12.161l-0.008-17.781L69.758,273.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M63.298,259.551c0.389,3.545,1.563,6.934,3.41,9.949l0.003,6.059 l0.008,17.926L36.21,275.527L63.298,259.551z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "63.155,253.688 63.155,256.13 34.867,272.815  34.852,236.926 50.021,245.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "63.155,217.938 63.155,249.849 51.559,242.98  36.158,233.861  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "63.155,212.113 63.155,214.434 34.877,231.113  34.868,213.331 34.86,195.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "63.155,176.768 63.155,208.611 36.217,192.755  51.531,183.666  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "63.155,170.321 63.155,172.876 50.049,180.654  34.887,189.652 34.87,153.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "63.155,135.065 63.155,166.818 36.21,150.959  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "63.155,129.118 63.155,131.562 34.867,148.246  34.852,112.357 50.021,121.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "63.155,93.337 63.155,125.248 51.559,118.38  36.158,109.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "63.155,87.513 63.155,89.833 34.877,106.512  34.868,88.73 34.86,70.858  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M66.704,74.732c-1.75,2.859-2.882,6.063-3.33,9.406 L36.217,68.153l15.314-9.088l15.162-8.997L66.704,74.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M91.813,63.155h-4.39c-6.423,0-12.572,2.488-17.116,7.037 l-0.113,0.114c-0.16,0.16-0.317,0.322-0.473,0.485l-0.009-20.725l15.169,8.982L91.813,63.155z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "101.618,63.155 98.414,63.155 86.448,56.069  71.049,46.949 101.603,28.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "107.833,63.155 104.637,63.155 104.62,29.071  135.068,46.992 119.799,56.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "136.449,63.155 114.391,63.155 121.281,59.065  136.443,50.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "161.563,63.155 139.468,63.155 139.462,50.067  154.632,59.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "171.368,63.155 168.164,63.155 156.199,56.069  140.799,46.949 171.353,28.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "177.583,63.155 174.387,63.155 174.371,29.071  204.818,46.992 189.55,56.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "206.199,63.155 184.141,63.155 191.032,59.065  206.193,50.068  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "231.313,63.155 209.219,63.155 209.212,50.067  224.383,59.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "241.119,63.155 237.914,63.155 225.949,56.069  210.55,46.949 241.104,28.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "247.334,63.155 244.138,63.155 244.122,29.071  274.569,46.992 259.3,56.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "275.95,63.155 253.891,63.155 260.782,59.065  275.944,50.068  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M308.146,68.753c-4.318-3.587-9.734-5.598-15.412-5.598h-13.766 l-0.006-13.088l15.17,8.982l15.201,9.003L308.146,68.753z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "310.814,70.889 310.693,70.755 310.814,70.684  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M317.001,104.671V87.422c0-4.352-1.142-8.582-3.137-12.206 l-0.002-4.357l30.265,17.813L317.001,104.671z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "317.001,110.351 317.001,108.175 345.714,91.239  345.73,127.363 330.561,118.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "317.001,146.399 317.001,114.222 329.023,121.34  344.225,130.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "317.001,152.012 317.001,149.903 345.705,132.974  345.713,150.99 345.721,168.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "317.001,187.805 317.001,155.515 344.319,171.593  329.051,180.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "317.001,193.804 317.001,191.696 330.533,183.666  345.695,174.669 345.711,210.703  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M333.941,219.28c-5.262-7.2-10.86-14.142-16.94-20.704v-1.27 l27.126,15.966L333.941,219.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    d: "M345.724,236.565c-3.222-5.028-6.543-9.983-10.007-14.829 l9.997-5.896L345.724,236.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M353.514,249.135c-1.571-2.609-3.159-5.208-4.77-7.79 l-0.012-25.361l30.447,17.921l-15.269,9.062L353.514,249.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M380.157,237.181v19.763c0,5.068-0.439,10.081-1.296,14.993 l-18.204-10.715c-1.799-3.089-3.608-6.172-5.438-9.241l10.205-6.057L380.157,237.181z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "380.157,195.524 380.157,230.977 350.072,213.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "380.157,153.793 380.157,189.38 365.45,180.67  350.051,171.551  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "380.157,112.612 380.157,148.13 350.108,130.443  365.424,121.355  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M378.728,71.767c0.944,5.113,1.43,10.353,1.43,15.655v18.954 l-30.085-17.707L378.728,71.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M377.775,67.276c0.108,0.453,0.213,0.907,0.314,1.362 L348.73,85.956l-0.017-35.889l15.17,8.982L377.775,67.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M364.613,38.36c5.251,7.328,9.266,15.534,11.898,24.26 l-11.062-6.551l-15.399-9.12L364.613,38.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M348.758,20.399c1.981,1.659,3.898,3.412,5.743,5.256 l1.019,1.025l-1.076,0.057c3.032,2.848,5.822,5.922,8.355,9.189l-14.03,8.274l-0.008-17.781L348.758,20.399z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M338.192,12.804c2.585,1.581,5.095,3.301,7.517,5.154 l0.004,8.432l0.008,17.925l-30.509-17.956L338.192,12.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M313.86,2.596c7.465,1.866,14.64,4.713,21.35,8.463 l-21.341,12.587L313.86,2.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M290.205,0h2.529c6.144,0,12.207,0.645,18.107,1.898l0.01,21.893 L280.358,5.843L290.205,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "278.997,0 283.706,0 278.998,2.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "271.26,0 275.979,0 275.98,2.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "244.108,0 264.777,0 274.474,5.742 244.119,23.646  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    points: "220.454,0 241.09,0 241.101,23.791 210.607,5.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "209.246,0 213.956,0 209.248,2.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "201.51,0 206.229,0 206.229,2.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "174.357,0 195.027,0 204.723,5.742 174.368,23.646  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "150.704,0 171.34,0 171.351,23.791 140.857,5.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "139.496,0 144.205,0 139.497,2.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "131.759,0 136.478,0 136.479,2.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "104.607,0 125.277,0 134.973,5.742 104.618,23.646  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M80.482,0.278C82.781,0.094,85.096,0,87.423,0h14.166 l0.011,23.791L71.106,5.843L80.482,0.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M69.746,1.82c0.809-0.169,1.621-0.326,2.436-0.472l-2.435,1.445 L69.746,1.82z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "66.383,2.59 66.729,2.505 66.729,2.795  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M34.865,17.725c8.188-6.212,17.36-10.913,27.107-13.907 l3.25,1.925L34.867,23.646L34.865,17.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M29.317,22.301c0.831-0.743,1.675-1.471,2.53-2.181l0.002,3.671 L29.317,22.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M19.335,32.807c1.971-2.443,4.079-4.794,6.321-7.037l0.114-0.114 c0.408-0.408,0.821-0.812,1.237-1.211l3.257,1.916L19.335,32.807z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M8.047,50.946c1.919-4.14,4.165-8.133,6.722-11.941 l17.083-10.076l0.017,36.124l-15.17-8.983L8.047,50.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M0.015,85.934c0.189-11.08,2.489-21.874,6.666-31.888l8.45,5.004 l15.201,9.003L0.015,85.934z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "0,127.359 0,91.394 30.427,109.303 15.158,118.364  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "0,210.543 0,174.691 15.131,183.651 30.332,192.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "0,251.961 0,215.995 30.427,233.904 15.158,242.966  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M6.362,289.628c-4.066-10.037-6.259-20.836-6.357-31.908 l30.26,17.811L6.362,289.628z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M13.325,303.241c-2.179-3.472-4.106-7.084-5.771-10.812 l24.298-14.331l0.017,36.124l-15.17-8.984L13.325,303.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M26.459,319.507l-0.803-0.798 c-2.787-2.789-5.367-5.741-7.73-8.834l12.406,7.347L26.459,319.507z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "315.673,275.256 316.229,276.125 315.212,275.527  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "313.869,272.474 314.03,272.72 313.869,272.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#737578",
    points: "345.614,251.675 330.667,242.72 316.798,234.412  316.798,232.854 345.614,215.696  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "378.592,233.702 363.537,242.72 348.59,251.675  348.59,215.84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "344.051,213.138 316.798,229.364 316.798,196.91  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M376.869,280.004c-2.562,9.073-6.548,17.564-11.699,25.215 l-0.105-0.063l-15.174-9.09L376.869,280.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M378.046,275.333c-0.041,0.185-0.079,0.37-0.121,0.553 l-29.296,17.443v-17.71v-17.801L378.046,275.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C3C6C6",
    d: "M380.013,261.178c-0.213,3.747-0.659,7.435-1.329,11.046 l-28.717-17.099l15.098-9.044l14.948-8.954V261.178z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 174.361,
    y: 285.039,
    width: 63.722,
    height: 59.326
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 174.361,
    y: 285.039,
    width: 63.722,
    height: 59.326,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.0801,
    y1: 312.4424,
    x2: 179.3159,
    y2: 339.8765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    style: {
      stopColor: "#CBCBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3696,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4992,
    style: {
      stopColor: "#434343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6276,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7546,
    style: {
      stopColor: "#111111"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8795,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174.349,
    y: 285.119,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#SVGID_2_)",
    width: 64.561,
    height: 59.166
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#SVGID_1_)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M175.717,317.323l30.494,17.948l-0.016-32.706 c-0.765-0.66-1.542-1.308-2.331-1.945l-12.832,7.614L175.717,317.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M209.215,305.285l0.014,29.841l16.841-9.934 C221.046,317.988,215.551,311.244,209.215,305.285z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "174.361,320.027 174.37,337.9 174.373,344.365  193.564,344.365 204.626,337.841  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "199.506,344.365 206.215,344.365 206.213,340.409  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    points: "209.232,344.365 215.71,344.365 209.231,340.552  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M227.779,327.688l-17.208,10.149l11.09,6.527h16.422 C234.784,338.662,231.397,333.062,227.779,327.688z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#313535",
    d: "M189.55,305.224l11.473-6.809 c-7.593-5.646-16.328-10.234-26.648-13.376l0.014,29.182L189.55,305.224z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "276.166,344.205 269.456,344.205 276.164,340.249  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M314.072,339.626c0.354,0.571,0.707,1.141,1.063,1.71 c-0.354,0.093-0.707,0.184-1.063,0.272V339.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M296.033,309.066l1.149,1.989 c1.91,3.308,3.819,6.613,5.737,9.908l-23.74,14.002l-0.017-35.89l15.17,8.983L296.033,309.066z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "276.154,257.383 276.163,275.399 276.171,293.324  245.662,275.367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "241.301,272.801 210.809,254.853 226.123,245.765  241.284,236.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "244.304,236.766 259.474,245.749 274.674,254.752  244.319,272.655  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    points: "311.015,319.693 311.023,337.71 311.031,355.635  280.522,337.679  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "279.163,299.076 294.333,308.06 309.534,317.063  279.18,334.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    points: "206.43,251.805 191.26,242.82 175.86,233.701  206.413,215.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "239.879,233.744 224.61,242.806 209.448,251.804  209.432,215.823  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    points: "204.826,213.112 174.578,230.953 174.57,213.172  174.562,195.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "345.931,376.373 330.761,367.39 315.361,358.27  345.914,340.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "344.327,337.681 314.079,355.521 314.07,337.74  314.063,319.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    points: "311.07,314.063 295.9,305.079 280.501,295.959  311.055,277.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "309.467,275.37 279.219,293.211 279.211,275.43  279.202,257.557  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    points: "415.662,459.806 385.169,441.857 400.484,432.769  415.646,423.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    points: "418.664,423.771 433.834,432.754 449.035,441.756  418.681,459.659  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    points: "345.905,382.076 345.913,400.093 345.922,418.019  315.412,400.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "314.054,361.46 329.224,370.443 344.425,379.445  314.07,397.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "380.821,438.757 365.65,429.772 350.251,420.653  380.805,402.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    points: "414.271,420.696 399.002,429.758 383.84,438.755  383.823,402.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "379.217,400.064 348.969,417.905 348.961,400.123  348.953,382.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "450.572,438.757 435.401,429.772 420.002,420.653  450.556,402.632  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M442.941,393.015c2.471,0.107,5.009,0.146,7.609,0.122 l0.002,4.358L442.941,393.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M418.707,389.519c5.438,1.406,11.252,2.43,17.484,3.025 l12.776,7.521l-30.248,17.841l-0.008-17.782L418.707,389.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    d: "M408.513,386.289c2.307,0.875,4.687,1.675,7.146,2.394 l0.006,11.41l0.008,17.926l-30.509-17.957L408.513,386.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M383.809,372.285c6.314,4.961,13.301,9.226,21.174,12.583 l-21.162,12.48L383.809,372.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M375.233,364.756c1.794,1.748,3.644,3.437,5.556,5.061 l0.013,27.679l-30.493-17.948l15.315-9.089L375.233,364.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M359.82,346.801c4.013,5.462,8.276,10.655,12.918,15.453 l-8.627,5.12l-15.162,8.998l-0.017-35.98L359.82,346.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M352.591,336.312c0.983,1.511,1.978,3.009,2.988,4.49 l-5.306-3.123L352.591,336.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M348.928,330.548c0.672,1.08,1.348,2.154,2.028,3.224 l-2.025,1.194L348.928,330.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M334.4,305.898l2.389,4.133 c3.018,5.227,6.031,10.441,9.118,15.57l0.005,9.51l-30.493-17.948l15.314-9.088L334.4,305.898z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M319.93,281.528c4.387,7.075,8.613,14.266,12.794,21.475 l-3.473,2.061l-15.162,8.998l-0.017-35.98L319.93,281.528z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M295.045,246.256c5.706,6.885,10.992,14.097,16.004,21.517 l0.003,5.028l-30.493-17.948L295.045,246.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M279.188,229.197c4.844,4.608,9.388,9.453,13.691,14.487 l-13.681,8.119L279.188,229.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M268.76,220.047c2.546,2.054,5.015,4.168,7.409,6.341 l0.012,25.417l-15.171-8.984l-15.399-9.119L268.76,220.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M244.316,203.818c7.921,4.244,15.183,9.019,21.904,14.223 l-21.893,12.912l-0.008-17.781L244.316,203.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M234.616,199.046c2.267,1.021,4.482,2.084,6.651,3.185 l0.005,10.91l0.008,17.926l-30.509-17.957L234.616,199.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M209.42,190.041c7.738,2.119,14.985,4.636,21.782,7.514 l-21.772,12.843L209.42,190.041z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M187.971,185.442c6.438,1.028,12.574,2.3,18.43,3.798 l0.011,21.303l-30.493-17.948L187.971,185.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M174.585,183.711c2.763,0.278,5.479,0.594,8.138,0.954 l-8.135,4.827L174.585,183.711z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M160.036,182.664c3.937,0.178,7.783,0.428,11.53,0.758 l0.003,6.072L160.036,182.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M137.57,211.492l-0.033-0.407v-29.93 c3.574,0.158,9.496,0.559,14.369,0.907l18.127,10.431L137.57,211.492z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    points: "140.915,212.92 171.514,195.124 171.522,213.141  171.53,231.066  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#70C7AD",
    points: "151.366,244.879 137.537,252.938 137.537,217.126  137.569,214.662 170.129,233.744 154.86,242.806  "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M171.547,264.323c-11.131-1.93-23.286-2.544-34.01-2.559V257.4 l18.835-11.636l15.162-8.997L171.547,264.323z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M183.864,267.173c-2.987-0.875-6.086-1.638-9.299-2.282 l-0.013-28.125l15.17,8.983l15.201,9.003L183.864,267.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M206.413,276.871c-5.71-3.352-11.905-6.209-18.674-8.479 l18.665-11.009l0.008,18.017L206.413,276.871z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M220.402,286.762c-3.442-2.88-7.08-5.564-10.94-8.021 l-0.001-3.311l-0.009-17.873l30.264,17.813L220.402,286.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M241.317,309.064c-5.579-7.323-11.653-14.162-18.497-20.224 l18.483-10.902L241.317,309.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M244.801,313.787c-0.154-0.215-0.308-0.432-0.463-0.646 l-0.016-35.06l30.447,17.921l-15.269,9.062L244.801,313.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M248.186,318.646c-0.48-0.709-0.963-1.414-1.45-2.115 l14.247-8.455l15.162-8.997l0.017,36.033L248.186,318.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M263.842,344.013c-3.854-6.636-7.765-13.236-11.882-19.644 l22.616,13.312L263.842,344.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M276.176,365.258c-2.938-4.989-5.842-10.017-8.749-15.051 l-2.07-3.584l10.808-6.374L276.176,365.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M281.869,374.787c-0.896-1.474-1.786-2.954-2.673-4.438 l-0.015-29.958l30.448,17.921l-15.269,9.062L281.869,374.787z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M287.282,383.504c-1.22-1.921-2.428-3.854-3.625-5.796 l12.216-7.25l15.162-8.997l0.017,36.034L287.282,383.504z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M301.75,404.616c-3.754-5.014-7.34-10.182-10.812-15.458 l18.528,10.906L301.75,404.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M311.061,416.277c-2.57-3.009-5.056-6.094-7.473-9.241 l7.467-4.404L311.061,416.277z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#939698",
    d: "M325.859,431.771c-4.128-3.833-8.041-7.857-11.779-12.04 l-0.008-16.955l30.447,17.921l-15.269,9.062L325.859,431.771z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M345.906,447.559c-6.236-4.106-12.03-8.606-17.457-13.434 l2.284-1.356l15.162-8.997L345.906,447.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C8E7E0",
    d: "M357.639,454.523c-2.999-1.593-5.898-3.273-8.713-5.029 l-0.012-25.724l15.17,8.983l15.201,9.002L357.639,454.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M380.774,464.376c-7.095-2.351-13.735-5.104-19.967-8.218 l19.958-11.771l0.008,18.017L380.774,464.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#515658",
    d: "M401.508,469.789c-6.194-1.216-12.08-2.702-17.685-4.437 l-0.001-2.918l-0.009-17.873l30.265,17.813L401.508,469.789z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M415.668,472.024c-3.29-0.397-6.495-0.869-9.629-1.403 l9.626-5.679L415.668,472.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#27B78A",
    d: "M432.835,473.415c-4.872-0.214-9.585-0.568-14.148-1.054 l-0.003-7.275L432.835,473.415z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5BC1A3",
    d: "M450.529,473.585c-3.896,0.09-7.698,0.096-11.412,0.025 l-19.094-11.238l30.492-17.985l0.009,18.017L450.529,473.585z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ);
export default __webpack_public_path__ + "static/media/q.d9df32b74ad46415dde18a760a039e34.svg";
export { ForwardRef as ReactComponent };